export const SIGNAL_SCORE_ADD = 'SIGNAL_SCORE_ADD';
export const SIGNAL_SCORE_REMOVE = 'SIGNAL_SCORE_REMOVE';
export const SIGNAL_SCORE_RESET = 'SIGNAL_SCORE_RESET';
export const SIGNAL_SCORE_SET = 'SIGNAL_SCORE_SET';
export const SIGNAL_SCORE_TITLE = 'Signal Score';
